import React, {useState} from "react";
import "./task-deliverables-for-offer.scss"

export const TaskDeliverablesForOffer: React.FC = ({ children }) => {
    return (
        <div className={'task-deliverables-for-offer'}>
            {children}
        </div>
    )
}